// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/capture_reviews.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { AddCaptureReviewFindingRequest, AddCaptureReviewFindingResponse, AddCaptureReviewMaterialRequest, AddCaptureReviewMaterialResponse, CloseCaptureReviewRequest, CloseCaptureReviewResponse, CreateCaptureReviewRequest, CreateCaptureReviewResponse, GetCaptureReviewRequest, GetCaptureReviewResponse, ListCaptureReviewsRequest, ListCaptureReviewsResponse, UpdateCaptureReviewRequest, UpdateCaptureReviewResponse } from "./capture_reviews_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * CaptureReviewService is the browser edge for SAD-487 / CAP-03: review cycles
 * on a Pursuit. A Review records purpose, date, participants, areas, readiness
 * and findings, and stands on its own — it never creates a go/no-go record
 * (it may be linked to one). Materials are server-side snapshots with the
 * source version that was discussed.
 *
 * Identity: tenant and acting user come from the gateway principal only.
 * Authorization is the capture_project policy on the pursuit's scope node:
 * `read` for List/Get, `update` for every write. A caller who cannot read the
 * pursuit gets no titles, content or counts, and reading a review grants
 * nothing beyond that.
 *
 * @generated from service mono.projectdata.v1.CaptureReviewService
 */ export const CaptureReviewService = {
    typeName: "mono.projectdata.v1.CaptureReviewService",
    methods: {
        /**
     * @generated from rpc mono.projectdata.v1.CaptureReviewService.ListCaptureReviews
     */ listCaptureReviews: {
            name: "ListCaptureReviews",
            I: ListCaptureReviewsRequest,
            O: ListCaptureReviewsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.CaptureReviewService.GetCaptureReview
     */ getCaptureReview: {
            name: "GetCaptureReview",
            I: GetCaptureReviewRequest,
            O: GetCaptureReviewResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.CaptureReviewService.CreateCaptureReview
     */ createCaptureReview: {
            name: "CreateCaptureReview",
            I: CreateCaptureReviewRequest,
            O: CreateCaptureReviewResponse,
            kind: MethodKind.Unary
        },
        /**
     * UpdateCaptureReview replaces the editable fields of an open review.
     *
     * @generated from rpc mono.projectdata.v1.CaptureReviewService.UpdateCaptureReview
     */ updateCaptureReview: {
            name: "UpdateCaptureReview",
            I: UpdateCaptureReviewRequest,
            O: UpdateCaptureReviewResponse,
            kind: MethodKind.Unary
        },
        /**
     * AddCaptureReviewMaterial freezes the named source into the review. The
     * server takes the snapshot; the client never supplies content.
     *
     * @generated from rpc mono.projectdata.v1.CaptureReviewService.AddCaptureReviewMaterial
     */ addCaptureReviewMaterial: {
            name: "AddCaptureReviewMaterial",
            I: AddCaptureReviewMaterialRequest,
            O: AddCaptureReviewMaterialResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.CaptureReviewService.AddCaptureReviewFinding
     */ addCaptureReviewFinding: {
            name: "AddCaptureReviewFinding",
            I: AddCaptureReviewFindingRequest,
            O: AddCaptureReviewFindingResponse,
            kind: MethodKind.Unary
        },
        /**
     * CloseCaptureReview is idempotent.
     *
     * @generated from rpc mono.projectdata.v1.CaptureReviewService.CloseCaptureReview
     */ closeCaptureReview: {
            name: "CloseCaptureReview",
            I: CloseCaptureReviewRequest,
            O: CloseCaptureReviewResponse,
            kind: MethodKind.Unary
        }
    }
};
